function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8 3.5C8.82843 3.5 9.5 2.82843 9.5 2C9.5 1.17157 8.82843 0.5 8 0.5C7.17157 0.5 6.5 1.17157 6.5 2C6.5 2.82843 7.17157 3.5 8 3.5Z",
  fill: "currentColor"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8.00005 15.2C8.66279 15.2 9.20005 14.6628 9.20005 14C9.20005 13.3373 8.66279 12.8 8.00005 12.8C7.33731 12.8 6.80005 13.3373 6.80005 14C6.80005 14.6628 7.33731 15.2 8.00005 15.2Z",
  fill: "currentColor"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M1.99995 9.04995C2.57985 9.04995 3.04995 8.57985 3.04995 7.99995C3.04995 7.42005 2.57985 6.94995 1.99995 6.94995C1.42005 6.94995 0.949951 7.42005 0.949951 7.99995C0.949951 8.57985 1.42005 9.04995 1.99995 9.04995Z",
  fill: "currentColor"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13.9999 9.3499C14.7455 9.3499 15.3499 8.74549 15.3499 7.9999C15.3499 7.25432 14.7455 6.6499 13.9999 6.6499C13.2543 6.6499 12.6499 7.25432 12.6499 7.9999C12.6499 8.74549 13.2543 9.3499 13.9999 9.3499Z",
  fill: "currentColor"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12.2429 5.18203C13.0299 5.18203 13.6679 4.54404 13.6679 3.75703C13.6679 2.97003 13.0299 2.33203 12.2429 2.33203C11.4559 2.33203 10.8179 2.97003 10.8179 3.75703C10.8179 4.54404 11.4559 5.18203 12.2429 5.18203Z",
  fill: "currentColor"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M3.75684 13.3679C4.37816 13.3679 4.88184 12.8642 4.88184 12.2429C4.88184 11.6216 4.37816 11.1179 3.75684 11.1179C3.13552 11.1179 2.63184 11.6216 2.63184 12.2429C2.63184 12.8642 3.13552 13.3679 3.75684 13.3679Z",
  fill: "currentColor"
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M3.75698 4.73198C4.29546 4.73198 4.73198 4.29546 4.73198 3.75698C4.73198 3.2185 4.29546 2.78198 3.75698 2.78198C3.2185 2.78198 2.78198 3.2185 2.78198 3.75698C2.78198 4.29546 3.2185 4.73198 3.75698 4.73198Z",
  fill: "currentColor"
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12.243 13.518C12.9472 13.518 13.518 12.9472 13.518 12.243C13.518 11.5389 12.9472 10.968 12.243 10.968C11.5389 10.968 10.968 11.5389 10.968 12.243C10.968 12.9472 11.5389 13.518 12.243 13.518Z",
  fill: "currentColor"
});

var SvgProgress = function SvgProgress(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProgress, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/progress.84f20646.svg";
export { ForwardRef as ReactComponent };